import request from '@/api/clients/portal-client'

export function getAiToolsList() {
  return request({
    url: '/aitools/list',
    method: 'get',
    params: { clientType: 'pc' }
  })
} 

export function getAiToolsTasksListByPage(params) {
  return request({
    url: '/aitasks/listPage',
    method: 'POST',
    params
  })
} 

export function getAiToolsTasksList(params = {}) {
  return request({
    url: '/aitasks/list',
    method: 'get',
    params: params // 确保参数正确传递
  })
}

// 获取单个任务详情，供 D63 结果页轮询进度和成品列表。
export function getAiToolsTaskInfo(id) {
  return request({
    url: '/aitasks/info',
    method: 'get',
    params: { id }
  })
}

// 终止 D63 口播视频批量制作任务。
export function terminateD63Task(id) {
  return request({
    url: '/aitasks/terminateD63',
    method: 'post',
    data: { id }
  })
}

// 终止 D64 视频混剪（快速版）任务。
export function terminateD64Task(id) {
  return request({
    url: '/aitasks/terminateD64',
    method: 'post',
    data: { id },
  })
}

// 删除单个任务
export function deleteTask(id) {
  return request({
    url: '/aitasks/delete',
    method: 'post',
    data: { id }
  })
}

// 批量删除文件
export function batchDeleteUserTasks(tasksIds) {
  return request({
    url: '/aitasks/batchDelete',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: JSON.stringify(tasksIds) // 直接传递数组
  })
}

// 添加任务
export function addTask(data) {
  return request({
    url: '/aitasks/add',
    method: 'post',
    data
  })
}

// 批量下载文件
export function batchDownloadFile(fileIds) {
  return request({
    url: '/aitasks/batchDownload',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: JSON.stringify(fileIds) // 直接传递数组
  })
}

// 修改任务状态
export function updateTask(id, status) {
  return request({
    url: '/aitasks/updateTask',
    method: 'post',
    data: { id, status }
  })
}

// 计算算力消耗
export function calculatePower(code, actualUsage) {
  return request({
    url: '/aitools/calculatePower',
    method: 'post',
    data: {
      code: code,
      actualUsage: actualUsage
    }
  })
}

// 删除云存储文件
export function deleteCloudFile(fileUrl) {
  return request({
    url: '/ksai/deleteCloudUrl',
    method: 'post',
    data: {
      fileUrl: fileUrl
    }
  })
}

// Gemini文案创作
export function geminiCopywritingCreate(data) {
  return request({
    url: '/ksai/geminiCopywritingCreate',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: {
      reference_text: data.reference_text,
      copy_count: data.copy_count || 5,
      min_words: data.min_words || 50,
      max_words: data.max_words || 200
    }
  })
}

// 获取闪剪智能剪辑模板列表
// scene 可选值: virtualman(虚拟人), realMan(真人), oralMixCutting(口播混剪), newsMixCutting(资讯混剪)
// sid: 分页游标，当有值时代表存在下一页，继续查询下一页时需传入该值
// pageSize: 每页数量
export function getShanjianTemplates(scene = 'realMan', sid = null, pageSize = 10) {
  const data = {
    scene: scene,
    pageSize: pageSize
  }
  
  // 只有当sid有值时才传递
  if (sid) {
    data.sid = sid
  }
  
  return request({
    url: '/ksai/getShanjianTemplates',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: data
  })
}

// 文案创作统一入口，model 可选 deepseek、gemini、gpt。
export function copywritingCreate(data) {
  return request({
    url: '/ksai/copywritingCreate',
    method: 'post',
    timeout: 15 * 60 * 1000,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      model: data.model || 'deepseek',
      reference_text: data.reference_text,
      copy_count: data.copy_count || 5,
      min_words: data.min_words || 50,
      max_words: data.max_words || 200,
      ...(data.include_translation !== undefined && { include_translation: data.include_translation }),
      ...(data.spoken_duration_radio !== undefined && data.spoken_duration_radio !== null && {
        spoken_duration_radio: data.spoken_duration_radio
      }),
      ...(data.spoken_duration_custom !== undefined && data.spoken_duration_custom !== null && {
        spoken_duration_custom: data.spoken_duration_custom
      })
    }
  })
}

// 个人 IP 定位问卷诊断（火山方舟 Doubao-Seed-2.1-lite）。
export function generateIpPositioningReport(data) {
  return request({
    url: '/ksai/ip-positioning-report',
    method: 'post',
    timeout: 240000,
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}
